import { z } from 'zod';
export const DIRECTORY_PROVIDERS = ['GOOGLE', 'ENTRA', 'SCIM'];
export const directoryProviderSchema = z.enum(DIRECTORY_PROVIDERS);
//# sourceMappingURL=directory-provider.js.map